// removed by extract-text-webpack-plugin
module.exports = {"imageWrapper":"src-pages----archive-module---imageWrapper---W5jEB","list":"src-pages----archive-module---list---4tiwP"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/archive.module.scss
// module id = 304
// module chunks = 63642485605921